import React from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Twemoji} from 'react-emoji-render';
import {increaseIndex} from '../../../../Actions/heatSpotAction';
import {ws} from '../../../../App';
import Avatar from '@material-ui/core/Avatar';
import Alert from '../../../../Helper/alert/alert';
import {withStyles} from '@material-ui/core/styles';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { emptyLiveChat } from "../../../../Actions/messagesAction";

const styles = {
    avatar: {
        marginLeft: 10,
        marginRight: 12,
        height: 40,
        width: 40,
        fontSize: 40,
        zIndex: 999,
        border: '1px solid grey',
        marginBottom: 10
    },
};

class LiveChatBody extends React.Component {
    constructor() {
        super();
        this.state = {
            dataToDelete: {},
            showDelete: false,
            deleteCount: 0,
            pressStart: 0,
            showLoadMessages: true,
            showMenuIcon: false
        };
    }

    componentWillReceiveProps(nextProps) {
        const { deleteCount, liveChatData, user } = nextProps;
        if(liveChatData && liveChatData.length === 0) {
            ws.json({
                chat_type: 'Business',
                count: 20,
                deleteCount: deleteCount,
                googlePlacedId: this.props.userDetails.BusinessUser.PlaceID,
                index: 0,
                requesterId: user.AppUser.UserId,
                type: 'businessrecentchat',
                user_id: this.props.userId,
            })

            nextProps.increaseMessageIndex(1);
        }
    }

    componentWillUnmount() {
        this.props.emptyLiveChat();
    }

    loadMoreMessages = () => {
        ws.json({
            "index": this.props.liveChatIndex,
            "count": 20,
            "user_id": this.props.userId,
            "type": "businessrecentchat",
            "chat_type": "Business",
            "deleteCount": this.state.deleteCount.toString(),
            "googlePlacedId": this.props.userDetails.BusinessUser.PlaceID
        });
        this.props.increaseIndex(this.props.liveChatIndex);
    };

    MouseDown = (e) => {
        this.setState({
            pressStart: e.timeStamp,
        });
    };

    MouseUp = (e, data) => {
        this.setState({
            showMenuIcon: !this.state.showMenuIcon
        });

        if ((this.state.pressStart + 1000) < e.timeStamp) {
            // if ((Number(data.UserId) === this.props.userId)) {
            //     this.setState({
            //         dataToDelete: {
            //             data: data
            //         },
            //         showDelete: true,
            //     });
            // }
            // else {
            //     this.setState({
            //         dataToDelete: {
            //             data: data
            //         },
            //         showDelete: true,
            //     });
            // }
        } else {
            this.imageClicked(e, data);
        }
    };

    MouseEnter = () => {
        this.setState({
            showMenuIcon: true
        });
    };

    MouseLeave = () => {
        this.setState({
            showMenuIcon: false
        });
    };

    MenuIconClicked = (e, data) => {
       // console.log("Menu Icon Clicked")
        // if ((Number(data.UserId) === this.props.userId)) {
            this.setState({
                dataToDelete: {
                    data: data
                },
                showDelete: true,
            });
        // }
        // else {
        //     this.setState({
        //         dataToDelete: {
        //             data: data
        //         },
        //         showDelete: true,
        //     });
        // }
    };

    imageClicked = (e, data) => {
        if (JSON.parse(data.CommentDetail).text === '[Sticker message]') {
            this.setState({
                audioURL: `https://d2gnb7jphto2jj.cloudfront.net/ChatImages/Sticker/Sounds/${JSON.parse(data.CommentDetail).stickerId.split('.')[0]}.wav`,
            });
        } else if (JSON.parse(data.CommentDetail).text === '[Picture message]') {
            let modal = document.getElementById('myModal');
            let targetDestination = document.getElementById('zoomImage');
            modal.style.display = "block";
            targetDestination.src = e.target.src;
        }
    };

    hideDelete = () => {
        this.setState({
            showDelete: false
        });
    };
    deleteChat = () => {
        ws.json({
            "chat_id": this.state.dataToDelete.data.CommentId,
            "user_id": this.state.dataToDelete.data.UserId,
            "type": "removebusinessmessage",
            "googlePlacedId": this.props.userDetails.BusinessUser.PlaceID,
            "chat_type": "Business"
        });
        this.setState({
            showDelete: false,
            deleteCount: this.state.deleteCount + 1,
        });
    };
    convertUnicode = (input) => {
        return input.replace(/\\u(\w\w\w\w)/g, (a, b) => {
            let charcode = parseInt(b, 16);
            return String.fromCharCode(charcode);
        });
    };
    render() {
        const {classes} = this.props;
        let previousDate;
        const { liveChatData, userId } = this.props;
        return (
            <React.Fragment>
                {
                    (liveChatData && liveChatData.chatReceived) < liveChatData.totalData
                    &&
                    <div className="load-live-messages" onClick={this.loadMoreMessages}>Load More Messages</div>
                }
                {
                    this.state.showDelete && <Alert
                        warning="true"
                        showCancel="true"
                        confirmText="Delete"
                        confirmStyle="danger"
                        cancelStyle="default"
                        title={<span>"Delete this message"</span>}
                        Confirm={this.deleteChat}
                        Cancel={this.hideDelete}
                    />
                }
                {

                    liveChatData.liveChat && liveChatData.liveChat.length > 0
                        ?
                        liveChatData.liveChat.map((chat, index) => {
                            let currentDate = moment();
                            // let finalDateA = moment(dateA);
                            let stillUTC = moment.utc(chat.CreatedDate).toDate();
                            let messageDate = moment(stillUTC).local();
                            // let dateB = moment(chat.CreatedDate).format("YYYY, M, DD");
                            // let finalDateB = moment(dateB);
                            let diff = currentDate.endOf('day').diff(messageDate, 'days');
                            let display = true;
                            if (previousDate === diff) {
                                display = false
                            }
                            previousDate = diff;

                            let res = /^(http:\/\/\.|https:\/\/\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm.test(JSON.parse(chat.CommentDetail).text);
                            return (
                                <div key={index} className="live-chats" onMouseLeave={(e) => {
                                    this.MouseLeave(e, chat)
                                }}>
                                    {
                                        display && (diff === 1 ?
                                                <p className="date-display">Yesterday</p>
                                                : diff === 0
                                                    ?
                                                    <p className="date-display">Today</p>
                                                    :
                                                    diff <=7
                                                        ?
                                                        <p className="date-display">{moment(chat.CreatedDate).format('dddd')}</p>
                                                        :
                                                        <p className="date-display">{moment(chat.CreatedDate).format("LL")}</p>

                                        )


                                        // display && (diff === 1 ?
                                        //     <p className="date-display">Yesterday</p>
                                        //     : diff > 1 ?
                                        //         <p className="date-display">{moment(chat.CreatedDate).local().format("LL")}</p>
                                        //         :
                                        //         <p className="date-display">Today</p>
                                        // )
                                    }

                                    {(Number(chat.UserId) !== this.props.userId) &&
                                    <p className="live-chat-username-receiver">{chat.First_Name}</p>}
                                    <div
                                        className={Number(chat.UserId) !== userId ? 'live-chat-wrapper-receiver' : 'live-chat-wrapper-sender'}
                                        onMouseLeave={(e) => {
                                            this.MouseLeave(e, chat)
                                        }}
                                    >
                                        {
                                            Number(chat.UserId) !== this.props.userId &&
                                            <div
                                                className={JSON.parse(chat.CommentDetail).text === '[Picture message]' || JSON.parse(chat.CommentDetail).text === '[Sticker message]' || JSON.parse(chat.CommentDetail).text === '[GIF message]' || JSON.parse(chat.CommentDetail).text === '[Gif message]' ? "sender-avatar sender-avatar" : "sender-avatar sender-text"}>
                                                <Avatar>
                                                     {/*className={classes.avatar}>*/}
                                                    {chat.Photo ? <img
                                                            src={require(`./../../../../images/Alphabets/${chat.First_Name.match(/[a-z]/i)[0].toUpperCase()}.png`)}
                                                            className="heatmap-infowindow-avatar-img"
                                                            onLoad={(e) => {

                                                                let extensions = ['jpg', 'jpeg', 'png'];
                                                                let arr = chat.Photo.split('.');
                                                                let result = extensions.indexOf(arr[arr.length - 1]);
                                                                if (result !== -1) {
                                                                    e.target.src = chat.Photo;
                                                                }
                                                            }}
                                                        />
                                                        :
                                                        <img
                                                            src={require(`./../../../../images/Alphabets/${chat.First_Name.match(/[a-z]/i)[0].toUpperCase()}.png`)}
                                                            height={65} width={65} alt="img"
                                                            style={{objectFit: 'cover'}}
                                                        />}
                                                </Avatar>
                                            </div>
                                        }
                                        {
                                            JSON.parse(chat.CommentDetail).text === '[Sticker message]'
                                                ?
                                                JSON.parse(chat.CommentDetail).stickerId.split('.')[0] > 0 && JSON.parse(chat.CommentDetail).stickerId.split('.')[0] <= 30
                                                    ?
                                                    <div className="live-chat-sticker">
                                                        <img
                                                            src={require(`../../../../images/Stickers/${JSON.parse(chat.CommentDetail).stickerId}`)}
                                                            alt="none" height={0} width={0} style={{display: 'none'}}
                                                        />
                                                        <img id="chatImage"
                                                             src={require(`../../../../images/glow.gif`)}
                                                             alt="stickerImage" height={90}
                                                             width={90}
                                                             style={{objectFit: 'cover'}}
                                                             onMouseDown={this.MouseDown}
                                                             onMouseEnter={(e) => {
                                                                 this.MouseEnter(e, chat)
                                                             }}
                                                             // onMouseUp={(e) => {
                                                             //    this.MouseUp(e, chat)
                                                             // }}
                                                             onLoad={(e) => {
                                                                 e.target.src = require(`../../../../images/Stickers/${JSON.parse(chat.CommentDetail).stickerId}`)
                                                             }}
                                                        >
                                                        </img>
                                                        {
                                                            this.state.showMenuIcon ? Number(chat.UserId) === userId ?
                                                                <DeleteOutlinedIcon className="menuIcon-sender" fontSize="large" style={{marginTop:'35px'}} onMouseUp={(e) => {
                                                                    this.MenuIconClicked(e, chat)
                                                                }}/>
                                                                 : <DeleteOutlinedIcon className="menuIcon-receiver" fontSize="large" style={{marginTop:'35px'}} onMouseUp={(e) => {
                                                                    this.MenuIconClicked(e, chat)
                                                                }}/> : ''
                                                        }
                                                    </div>
                                                    :
                                                    <div className="live-chat-image">
                                                        <img
                                                            src={`https://d2gnb7jphto2jj.cloudfront.net/ChatImages/Sticker/Images/${JSON.parse(chat.CommentDetail).stickerId}`}
                                                            alt="none" height={0} width={0} style={{objectFit: 'cover'}}
                                                        />
                                                        <img id="chatImage"
                                                             src={require('../../../../images/glow.gif')}
                                                             alt="stickerImage" height={90}
                                                             width={90}
                                                             style={{objectFit: 'cover'}}
                                                             onMouseDown={this.MouseDown}
                                                             onMouseEnter={(e) => {
                                                                 this.MouseEnter(e, chat)
                                                             }}
                                                             // onMouseUp={(e) => {
                                                             //    this.MouseUp(e, chat)
                                                             // }}
                                                             onLoad={(e) => {
                                                                 e.target.src = `https://d2gnb7jphto2jj.cloudfront.net/ChatImages/Sticker/Images/${JSON.parse(chat.CommentDetail).stickerId}`;
                                                             }}
                                                        />
                                                        {
                                                            this.state.showMenuIcon ? Number(chat.UserId) === userId ?
                                                                <DeleteOutlinedIcon className="menuIcon-sender" fontSize="large" style={{marginTop:'35px'}} onMouseUp={(e) => {
                                                                    this.MenuIconClicked(e, chat)
                                                                }}/> : <DeleteOutlinedIcon className="menuIcon-receiver" fontSize="large" style={{marginTop:'35px'}} onMouseUp={(e) => {
                                                                    this.MenuIconClicked(e, chat)
                                                                }}/> : ''
                                                        }
                                                    </div>
                                                :
                                                (JSON.parse(chat.CommentDetail).text === '[Picture message]' || JSON.parse(chat.CommentDetail).text === '[GIF message]' || JSON.parse(chat.CommentDetail).text === '[Gif message]')
                                                ?
                                                    JSON.parse(chat.CommentDetail).imgUrl.split('.')[3] === 'gif'
                                                    ?
                                                        <div>
                                                            <img id="chatImage"
                                                                 src={JSON.parse(chat.CommentDetail).imgUrl}
                                                                 alt="img"
                                                                 height={90}
                                                                 width={150}
                                                                 style={{objectFit: 'cover'}}
                                                                 onMouseDown={this.MouseDown}
                                                                 onMouseEnter={(e) => {
                                                                     this.MouseEnter(e, chat)
                                                                 }}
                                                                 // onMouseUp={(e) => {
                                                                 //     this.MouseUp(e, chat)
                                                                 // }}
                                                            />
                                                            {
                                                                this.state.showMenuIcon ? Number(chat.UserId) === userId ?
                                                                    <DeleteOutlinedIcon className="menuIcon-sender" fontSize="large" style={{marginTop:'35px'}} onMouseUp={(e) => {
                                                                        this.MenuIconClicked(e, chat)
                                                                    }}/> : <DeleteOutlinedIcon className="menuIcon-receiver" fontSize="large" style={{marginTop:'35px'}} onMouseUp={(e) => {
                                                                        this.MenuIconClicked(e, chat)
                                                                    }}/>
                                                                    : ''
                                                            }
                                                        </div>
                                                    :
                                                        <div>
                                                            <img
                                                                src={JSON.parse(chat.CommentDetail).imgUrl}
                                                                alt="none" height={0} width={0}
                                                                style={{objectFit: 'cover'}}
                                                            />
                                                            <img id="chatImage"
                                                                 src={require('../../../../images/glow.gif')}
                                                                 alt="img"
                                                                 height={90}
                                                                 width={150}
                                                                 style={{objectFit: 'cover',marginRight:'10px'}}
                                                                 onMouseDown={this.MouseDown}
                                                                 onMouseEnter={(e) => {
                                                                     this.MouseEnter(e, chat)
                                                                 }}
                                                                 // onMouseUp={(e) => {
                                                                 //    this.MouseUp(e, chat)
                                                                 // }}
                                                                 onLoad={(e) => {
                                                                     e.target.src = JSON.parse(chat.CommentDetail).imgUrl;
                                                                 }}
                                                            >
                                                            </img>
                                                            {
                                                                this.state.showMenuIcon ? Number(chat.UserId) === userId ?
                                                                    <DeleteOutlinedIcon className="menuIcon-sender" fontSize="large" style={{marginTop:'35px'}} onMouseUp={(e) => {
                                                                        this.MenuIconClicked(e, chat)
                                                                    }}/> : <DeleteOutlinedIcon className="menuIcon-receiver" fontSize="large" style={{marginTop:'35px'}} onMouseUp={(e) => {
                                                                        this.MenuIconClicked(e, chat)
                                                                    }}/>
                                                                    : ''
                                                            }
                                                        </div>
                                                :
                                                        <div
                                                            className={Number(chat.UserId) !== userId ? 'live-chat-bubble-receiver' : 'live-chat-bubble-sender'}
                                                            onMouseDown={this.MouseDown}
                                                            onMouseEnter={(e) => {
                                                                this.MouseEnter(e, chat)
                                                            }}
                                                            // onMouseUp={(e) => {
                                                            //   this.MouseUp(e, chat)
                                                            // }}
                                                        >
                                                            <p className="live-chat-text">{!res ? <Twemoji
                                                                text={this.convertUnicode(JSON.parse(chat.CommentDetail).text)}/> : JSON.parse(chat.CommentDetail).text}
                                                            </p>
                                                        </div>
                                        }
                                        {
                                            this.state.showMenuIcon ?
                                            Number(chat.UserId) === userId && JSON.parse(chat.CommentDetail).text !== '[Sticker message]' && JSON.parse(chat.CommentDetail).text !== '[Picture message]' && JSON.parse(chat.CommentDetail).text !== '[Gif message]' && JSON.parse(chat.CommentDetail).text !== '[GIF message]' ?
                                                <DeleteOutlinedIcon className="menuIcon-sender" fontSize="large" onMouseUp={(e) => {
                                                    this.MenuIconClicked(e, chat)
                                                }}/> : JSON.parse(chat.CommentDetail).text !== '[Sticker message]' && JSON.parse(chat.CommentDetail).text !== '[Picture message]' && JSON.parse(chat.CommentDetail).text !== '[Gif message]' && JSON.parse(chat.CommentDetail).text !== '[GIF message]' ? <DeleteOutlinedIcon className="menuIcon-receiver" fontSize="large" onMouseUp={(e) => {
                                                    this.MenuIconClicked(e, chat)
                                                }}/> : ''  : ''
                                        }
                                    </div>
                                    <p className={Number(chat.UserId) === userId ? 'time-display text-right' : 'time-display-receiver text-left'}>{moment(moment.utc(chat.CreatedDate).toDate()).local().format('LT')}</p>

                                    {/*<p>{moment(moment.utc(chat.CreatedDate).toDate()).local().format('LT')}</p>*/}
                                    {/*<p>{chat.CreatedDate}</p>*/}
                                    {/*moment(moment.utc(data.startDateTime,'MM/DD/YYYY hh:mm A').toDate()).local().format('MM/DD/YYYY hh:mm A');*/}
                                </div>
                            )
                        }) : ""
                }

            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.loginResponse.results,
        userId: state.loginResponse.results.AppUser.UserId,
        liveChatData: state.liveChatReducer,
        liveChatIndex: state.liveChatReducer.liveChatIndex,
    };
};

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        increaseIndex,
        emptyLiveChat
    }, dispatch);
};

export default connect(mapStateToProps, matchDispatchToProps)(LiveChatBody);
